export const FETCH = 'defaultFavorites/FETCH';
export const FETCH_SUCCESS = 'defaultFavorites/FETCH_SUCCESS';
export const FETCH_ERROR = 'defaultFavorites/FETCH_ERROR';

export const FETCH_DASHBOARDS_WITH_DEFAULT_FAVORITE = 'defaultFavorites/FETCH_DASHBOARDS_WITH_DEFAULT_FAVORITE';
export const FETCH_DASHBOARDS_WITH_DEFAULT_FAVORITE_SUCCESS =
  'defaultFavorites/FETCH_DASHBOARDS_WITH_DEFAULT_FAVORITE_SUCCESS';
export const FETCH_DASHBOARDS_WITH_DEFAULT_FAVORITE_ERROR =
  'defaultFavorites/FETCH_DASHBOARDS_WITH_DEFAULT_FAVORITE_ERROR';

export const ADD_FAVORITE = 'defaultFavorites/ADD_FAVORITE';
export const ADD_FAVORITE_SUCCESS = 'defaultFavorites/ADD_FAVORITE_SUCCESS';
export const ADD_FAVORITE_ERROR = 'defaultFavorites/ADD_FAVORITE_ERROR';

export const REMOVE_FAVORITE = 'defaultFavorites/REMOVE_FAVORITE';
export const REMOVE_FAVORITE_SUCCESS = 'defaultFavorites/REMOVE_FAVORITE_SUCCESS';
export const REMOVE_FAVORITE_ERROR = 'defaultFavorites/REMOVE_FAVORITE_ERROR';
